module.exports = "<div class=\"form-box border-btm\" [style.display]=\"disabled?'none':'block'\">\n    <h5 class=\"padTP20\">{{prompt}} <label class=\"checkbox-inline pull-right desktopHide\"></label></h5>\n    <ng-template #subsectionContainer></ng-template>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/subsection.component.html
// module id = ../../../../../src/app/pages/questionnaire/elements/subsection.component.html
// module chunks = main